import { render, staticRenderFns } from "./ReturnSalesReport.vue?vue&type=template&id=40b81b62"
import script from "./ReturnSalesReport.vue?vue&type=script&lang=js"
export * from "./ReturnSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports